module.exports = __webpack_public_path__ + "static/media/trotting-large.3a9af115.svg";